import './KidoHeader.css';

import React, { useState, useEffect } from 'react';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useTranslation } from 'react-i18next';

import Logo from './Logo';

import { useCart } from '../../../../context/CartContext';

import { useAuth } from '../../../../context/AuthContext';

import LanguageSwitcher from '../../../../translation/languageSwitcher';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const { getCartCount } = useCart();
  const { isAuthenticated, user, logout } = useAuth();

  const { t } = useTranslation();

  const cartCount = getCartCount();

  const closeMenu = () => setMenuOpen(false);

  // Close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Lock body scroll while mobile menu is open
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  const handleLogout = () => {
    logout();
    navigate('/shop');
    setMenuOpen(false);
  };

  return (
    <header className="kido-nav-wrap">

      {/* LOGO */}
      <Link
        className="kido-logo"
        to="/"
        aria-label={t('header.home')}
        onClick={closeMenu}
      >
        <Logo />
      </Link>

      {/* MAIN NAVIGATION */}
      <nav
        className={
          menuOpen
            ? 'kido-nav-links kido-open'
            : 'kido-nav-links'
        }
        aria-label="Main navigation"
      >
        {/* Home */}
        <Link to="/" onClick={closeMenu}>
          {t('header.home')}
        </Link>

        {/* Products */}
        <Link to="/shop" onClick={closeMenu}>
          {t('header.products')}
        </Link>

        {/* Orders */}
        <Link to="/my-orders" onClick={closeMenu}>
          {t('header.orders')}
        </Link>

        {/* Contact */}
        <Link to="/contact" onClick={closeMenu}>
          {t('header.contact')}
        </Link>
      </nav>

      {/* RIGHT ACTIONS */}
      <div className="kido-nav-actions">

        {/* LANGUAGE */}
        <div
          className="kido-languages"
          aria-label={t('header.language')}
        >
          <LanguageSwitcher />
        </div>

        {/* SEARCH */}
        <Link
          className="kido-action-link"
          to="/shop"
          aria-label={t('header.search')}
          title={t('header.search')}
          onClick={closeMenu}
        >
          <img
            src={require('../../../../assets/search.png')}
            alt={t('header.search')}
            style={{ width: '20px', height: '20px' }}
          />
        </Link>

        {/* FAVORITES */}
        <Link
          className="kido-action-link"
          to="/favorites"
          aria-label={t('header.favorites')}
          title={t('header.favorites')}
          onClick={closeMenu}
        >
          <img
            src={require('../../../../assets/favourites.png')}
            alt={t('header.favorites')}
            style={{ width: '20px', height: '20px' }}
          />
        </Link>

        {/* LOGIN / LOGOUT */}
        {isAuthenticated ? (
          <button
            type="button"
            className="kido-action-button"
            onClick={handleLogout}
            aria-label={t('header.logout')}
            title={t('header.logout')}
            style={{ width: '20px', height: '20px', marginBottom: '5px', backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}
          >
            <img
              src={require('../../../../assets/logout1.png')}
              alt={t('header.logout')}
              style={{ width: '20px', height: '20px', backgroundColor: 'transparent' }}
            />
          </button>
        ) : (
          <Link
            className="kido-action-link"
            to="/login"
            aria-label={t('header.login')}
            title={t('header.login')}
            onClick={closeMenu}
          >
            <img
              src={require('../../../../assets/login_icon.png')}
              alt={t('header.login')}
              style={{ width: '20px', height: '20px' }}
            />
          </Link>
        )}

        {/* CART */}
        <Link
          className="kido-bag"
          to="/cart"
          aria-label={`${t('header.cart')}, ${cartCount} items`}
          title={t('header.cart')}
          onClick={closeMenu}
        >
          <img
            src={require('../../../../assets/cart.png')}
            alt={t('header.cart')}
            style={{ width: '20px', height: '20px', marginBottom: '5px' }}
          />

          {cartCount > 0 && (
            <span>{cartCount}</span>
          )}
        </Link>

        {/* MOBILE MENU BUTTON */}
        <button
          type="button"
          className="kido-menu-button"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <i />
          <i />
        </button>
      </div>      
    </header>
  );
}